module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.policyList.length) ? _c('div', {
    staticClass: "service-tip-tag-web"
  }, [_c('div', {
    staticClass: "popup-content"
  }, [(!_vm.hiddenTabs) ? _c('div', {
    staticClass: "popup-head"
  }, [_c('div', {
    staticClass: "popup-tabs"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('div', {
      key: index,
      staticClass: "popup-tab-item",
      class: {
        'popup-tab-item-active': _vm.activeTab === index || _vm.tabs.length === 1
      },
      on: {
        "click": function($event) {
          return _vm.onTabChange(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tab) + "\n        ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "scroll-container",
    staticClass: "popup-body",
    style: (_vm.hiddenTabs ? 'margin-top:16px;' : '')
  }, _vm._l((_vm.tabs), function(tabName, index) {
    return _c('div', {
      key: ("tab" + index),
      ref: ("tab" + index + "-ref"),
      refInFor: true,
      staticClass: "popup-section"
    }, [(index === 0 && _vm.policyList.length) ? [_c('div', {
      staticClass: "popup-section-title"
    }, [_vm._v(_vm._s(tabName))]), _vm._v(" "), _vm._l((_vm.policyList), function(item, index) {
      return _c('refund-policy', {
        key: index,
        attrs: {
          "refund-policy": item,
          "scene": "TAG",
          "last-child": _vm.policyList.length - 1 === index
        }
      })
    })] : _vm._e(), _vm._v(" "), (index === 1) ? [_c('div', {
      staticClass: "popup-section-title"
    }, [_vm._v(_vm._s(tabName))]), _vm._v(" "), (_vm.activity.id) ? _c('tip-info', {
      attrs: {
        "activity": _vm.activity
      }
    }) : _vm._e()] : _vm._e()], 2)
  }), 0)])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-409dc3d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-409dc3d4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/about/ServiceTipTagWeb.vue
// module id = 2247
// module chunks = 47